import { ICellRendererParams } from 'ag-grid-community';

import { ElementFormField } from 'bom/components';
import { ElementType } from 'bom/enums';
import { IElement } from 'bom/types';
import { TextEllipsis } from 'core/elements';
import { useFormContext } from 'core/states';
import { getAgGridTableCellData } from 'core/utils';

interface IProps extends ICellRendererParams {
  jobId: number;
}

export const ElementCell = ({ jobId, ...props }: IProps) => {
  const data = getAgGridTableCellData(props, 'element');

  const { setValue } = useFormContext();

  if (!data) {
    return null;
  }

  const rowIndex = props.node.rowIndex;

  const isRowEditable =
    (!data?.element?.id &&
      !data?.element?.empty &&
      ![ElementType.ID_OVERAGE, ElementType.ID_SHORTAGE].includes(
        data?.element?.id as ElementType
      )) ||
    data?.isNew;

  if (!isRowEditable) {
    return <TextEllipsis content={data?.element?.name} />;
  }

  const onCloseAddNewElement = () => {
    setValue(`elements.${rowIndex}.element`, null);
  };

  const onChange = (element: Partial<IElement>) => {
    props.setValue(element);

    if (element?.quantity) {
      props.node.setDataValue('quantity', element?.quantity);
    }

    if (element?.line) {
      props.node.setDataValue('line', element?.line);
    }
  };

  return (
    <ElementFormField
      jobId={jobId}
      name={`elements.${rowIndex}.element`}
      label={null}
      onChange={onChange}
      onCloseAddNewElement={onCloseAddNewElement}
      required
    />
  );
};
